import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { publicFaqs } from '../../utils/commerce';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const items = publicFaqs();
  return <section id="faq" className="scroll-mt-4 bg-ivory" data-id="element-73" data-mp="uq9cjly8o33a">
      <div className="mx-auto grid max-w-site gap-10 px-5 py-20 md:px-8 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-74" data-mp="usvv0gmo430a">
        <div className="lg:col-span-4" data-id="element-75" data-mp="731jq3hzymi5">
          <p className="font-mono text-[12px] uppercase tracking-[0.16em] text-copperDeep" data-id="element-76" data-mp="22x1a7xj3hpa">FAQs</p>
          <h2 className="mt-4 font-display text-[32px] font-bold leading-[1.1] text-ink lg:text-[42px]" data-id="element-77" data-mp="gzo2mmqrj3hj">Frequently asked questions</h2>
        </div>
        <ul className="border-t border-ink/80 lg:col-span-8" data-id="element-78" data-mp="c2e48hlebhhk">
          {items.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} className="border-b border-rule" data-id="element-79" data-mp="1neeygc113y4p" data-mpi={i}>
                <h3 data-id="element-80" data-mp="htzfk3g85vq9">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex min-h-[64px] w-full items-center justify-between gap-6 py-4 text-left font-display text-[18px] font-semibold text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink" data-id="element-81" data-mp="huimkp4c6zpi">
                    {f.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-copperDeep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-82" data-mp="42ubmp5tqha4" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-83" data-mp="3ch30bm586nx0">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-84" data-mp="3gj7sshjxtei2">
                      <p className="max-w-[660px] pb-6 text-[17px] leading-[1.65] text-inkSoft" data-id="element-85" data-mp="sffvox71a2m3">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}